import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href", "target"];
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["src", "alt"];
import { computed, onMounted, onUnmounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UIcon',
    props: {
        icon: {},
        isLink: { type: Boolean, default: false },
        href: { default: "#" },
        target: { default: "_self" },
        clickable: { type: Boolean, default: false },
        iconSize: { default: "16px" }
    },
    emits: ["click"],
    setup(__props) {
        const props = __props;
        const isDark = ref(false);
        const updateTheme = () => {
            isDark.value = document.documentElement.classList.contains("app-dark");
        };
        let observer = null;
        onMounted(() => {
            updateTheme();
            observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        updateTheme();
                    }
                });
            });
            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["class"]
            });
        });
        onUnmounted(() => {
            if (observer) {
                observer.disconnect();
            }
        });
        const theme = computed(() => {
            return isDark.value ? "dark" : "light";
        });
        const iconPath = computed(() => {
            if (props.icon.includes("/")) {
                return props.icon;
            }
            return `/svg/${theme.value}/${props.icon}.svg`;
        });
        const cssVars = computed(() => ({
            width: props.iconSize,
            height: props.iconSize
        }));
        return (_ctx, _cache) => {
            return (__props.isLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: __props.href,
                    target: __props.target,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
                }, [
                    _createElementVNode("img", {
                        src: iconPath.value,
                        alt: __props.icon,
                        style: _normalizeStyle(cssVars.value),
                        class: _normalizeClass({ clickable: __props.clickable })
                    }, null, 14, _hoisted_2)
                ], 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: iconPath.value,
                    alt: __props.icon,
                    style: _normalizeStyle(cssVars.value),
                    class: _normalizeClass({ clickable: __props.clickable }),
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('click')))
                }, null, 14, _hoisted_3));
        };
    }
});
